module.exports = __webpack_public_path__ + "img/msg_a.31765c20.png";